exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".TrunctatedText__text__3qeec{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.TrunctatedText__fullText__11XFY{position:fixed}", "", {"version":3,"sources":["/mnt/d/asofts/vvs/cirrus/Cirrus/frontend/src/components/controls/src/components/controls/TrunctatedText.scss"],"names":[],"mappings":"AAAA,6BACI,gBAAgB,AAChB,uBAAuB,AACvB,kBAAmB,CACtB,AAED,iCACI,cAAe,CAClB","file":"TrunctatedText.scss","sourcesContent":[".text {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.fullText {\n    position: fixed;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"text": "TrunctatedText__text__3qeec",
	"fullText": "TrunctatedText__fullText__11XFY"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-2!./node_modules/sass-loader/lib/loader.js??ref--1-3!./src/components/controls/TrunctatedText.scss
// module id = ./node_modules/css-loader/index.js??ref--1-2!./node_modules/sass-loader/lib/loader.js??ref--1-3!./src/components/controls/TrunctatedText.scss
// module chunks = 0